interface MarketplaceCountyPlanCounts {
  countySSA: string;
  totalPlanCount: number;
  payers: MarketplacePayerPlanCount[];
  metalTiers: MarketplaceMetalTierCount[];
}

interface MarketplacePayerPlanCount {
  payerName: string;
  planCount: number;
}

interface MarketplaceMetalTierCount {
  metalLevel: MarketplaceMetalTier;
  planCount: number;
}

enum MarketplaceMetalTier {
  unknown = "unknown",
  low = "low",
  high = "high",
  bronze = "bronze",
  expandedBronze = "expandedBronze",
  silver = "silver",
  gold = "gold",
  platinum = "platinum",
  catastrophic = "catastrophic"
}

export { MarketplaceCountyPlanCounts, MarketplaceMetalTier, MarketplaceMetalTierCount, MarketplacePayerPlanCount };